/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const itemCountSchema = z.object({
  completed: z.int(),
  notCompleted: z.int(),
});
